import React from "react";

function ExpectedOutputField({ data, onChange, disabled, index }) {
    return (
        <div className="addrules-form-group-v2" key={index}>
            <label className="addrules-form-label-v2">Expected output</label>
            <textarea
                className="addrules-form-textarea-v2 monospace"
                rows="3"
                value={data.output || ''}
                disabled={disabled}
                onChange={disabled ? null : event => onChange(event.target.value)}
            />
        </div>
    )

}

export default ExpectedOutputField;
